// Keep page headings and sidebar labels on the same translation/fallback path.
export function getRouteDisplayName({ key, name }, t) {
  if (!key) return name;
  const translationKey = key === "warehouses" ? "warehouses.default" : key;
  const translated = t(translationKey);
  let displayName = translated && translated !== translationKey ? translated : name;
  if (typeof displayName === "object" && displayName !== null) {
    displayName = displayName.zh || displayName.en || "";
  }
  return displayName || key;
}
